import { useContext, useEffect } from "react";
import { DataContext } from "../providers/DataProvider";

function CopperDuplicatesPage() {
  const { getCopperDuplicatesLeads, getCopperDuplicates } =
    useContext(DataContext);

  useEffect(() => {
    getCopperDuplicates();
  }, []);

  // Get the duplicates object and convert to array if needed
  const duplicatesEntries = getCopperDuplicatesLeads.duplicates
    ? Object.entries(getCopperDuplicatesLeads.duplicates)
    : [];

  return (
    <div>
      <div className="bg-gray-50 min-h-screen pb-10">
        <div className="bg-gradient-to-r from-purple-800 to-blue-900 text-white py-8 px-4 mb-6 shadow-lg">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-3xl font-bold">Copper CRM</h1>
            <p className="text-blue-100 mt-2">Duplicate Leads</p>
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4">
          <div className="bg-white shadow-md rounded-lg p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-blue-100 p-4 rounded-lg text-center">
                <h3 className="text-blue-800 text-lg font-semibold mb-2">
                  Total Leads
                </h3>
                <div className="text-3xl font-bold text-blue-900">
                  {getCopperDuplicatesLeads.total || 0}
                </div>
              </div>
              <div className="bg-purple-100 p-4 rounded-lg text-center">
                <h3 className="text-purple-800 text-lg font-semibold mb-2">
                  Duplicate Leads
                </h3>
                <p className="text-3xl font-bold text-purple-900">
                  {getCopperDuplicatesLeads.count || 0}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 mt-6">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            Duplicate Leads
          </h2>
          {duplicatesEntries.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {duplicatesEntries.map(([email, leads]) => (
                <div key={email} className="bg-white rounded-lg shadow-md">
                  <div className="flex p-3">
                    <a
                      href={`https://app.copper.com/companies/36887/app#/search-results/all/%7B%22phrase%22:%22${email}%22%7D/`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-800 p-1 rounded hover:bg-blue-50"
                      title="Open lead in Copper CRM"
                    >
                      <div className="p-4   bg-blue-100 rounded-full flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                          />
                        </svg>
                      </div>
                    </a>
                    <div className="flex ml-4 items-center justify-center">
                      <h3 className="text-sm text-gray-800">{email}</h3>
                    </div>
                  </div>
                  {leads.map((lead) => (
                    <div
                      key={lead.id}
                      className="border rounded-lg p-4 bg-gray-50 hover:shadow-md transition-shadow"
                    >
                      <div className="mb-2 pb-2 border-b">
                        <p className="text-sm text-gray-500">ID: {lead.id}</p>
                      </div>
                      <h4 className="font-medium text-sm text-gray-800 mb-1">
                        {lead.name || "Unnamed Lead"}
                      </h4>
                      <p className="text-sm text-gray-600">
                        <span className="inline-block bg-blue-100 text-blue-800 rounded-full px-2 py-1 text-xs font-semibold mr-2">
                          {lead.company || "No Company"}
                        </span>
                      </p>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          ) : (
            <div className="bg-white rounded-lg shadow-md p-10 text-center">
              <div className="flex flex-col items-center justify-center">
                <svg
                  aria-hidden="true"
                  className="w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <h2 className="mt-4 text-xl font-semibold text-gray-700">
                  Loading duplicate lead data...
                </h2>
                <p className="mt-2 text-gray-500">
                  This may take a moment to retrieve all records
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CopperDuplicatesPage;
